import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '@hlt/web-kit/shell';

export const Route = createFileRoute('/_app')({
    beforeLoad: async ({ context, location }) => await requireSession(context.queryClient, location.href),
    component: Outlet,
});
